import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { getSiteSettings } from '../../services/apiClient';
import type { SiteSettings } from '../../types';
import styles from './PublicLayout.module.css';

export function PublicLayout() {
  const [settings, setSettings] = useState<SiteSettings | null>(null);

  useEffect(() => {
    getSiteSettings().then((res) => {
      if (res.data) setSettings(res.data);
    });
  }, []);

  if (!settings) return null;

  return (
    <div className={styles.layout}>
      <PublicHeader
        orgName={settings.display_name}
        logoUrl={settings.logo_url}
        ctaText={settings.default_cta_text}
      />
      <main className={styles.main}>
        <Outlet />
      </main>
      <PublicFooter settings={settings} />
    </div>
  );
}
